import { CredentialsDataGrid } from 'src/common/credentials/CredentialsDataGrid/CredentialsDataGrid';
import { useCredentialClearState } from 'src/common/credentials/useCredentialClearState';

export function VehicleCredentialsRoute() {
  useCredentialClearState();

  return <CredentialsDataGrid category="Vehicle" />;
}
